// Attributes a touchpoint response can write; segment conditions reference them.
export const attributes = [
  { attribute_id: 501, name: 'Pet.Allergies' },
  { attribute_id: 502, name: 'Pet.Diet' },
  { attribute_id: 503, name: 'Pet.Severe' },
];

export const attributeById = (id) => attributes.find((a) => a.attribute_id === id) || null;
